<script lang="ts">
  import { onMount } from "svelte";
  import { push } from "svelte-spa-router";
  import { GUEST_TRIAL_STORAGE_KEY } from "../../js/guestTrialProducts";

  onMount(() => {
    localStorage.setItem(GUEST_TRIAL_STORAGE_KEY, "btob");
    push("/guest-brief-builder");
  });
</script>

<div class="redirecting" aria-live="polite">Opening Built-to-Brief…</div>

<style>
  .redirecting {
    padding: var(--space-6);
    color: var(--grey-secondary);
  }
</style>
